import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom'
import { Divider, Typography } from '@mui/material';
import CheckIcon from '../assets/images/check.svg'
import CrossIcon from '../assets/images/crossIcon.svg'
import { Button } from '../components';
import { reservationConfirmationPageConstants as staticConstants } from '../assets/constants/ReservationConfirmationPageConstants';
import { setIsConfirmationPageAccessible } from '../features/globalStates/globalStatesSlice';
import './ReservationConfirmationPage.css';

const ReservationConfirmationPage = () => {
  const history = useHistory();
  const locale = useSelector((state) => state.globalStates.locale);
  const { userData } = useSelector((store) => store?.commerce);
  const isConfirmationPageAccessible = useSelector((state) => state.globalStates.isConfirmationPageAccessible)
  const { reservation } = useSelector((store) => store?.commerce);
  const dispatch = useDispatch();
  const { reservationId } = useParams();
  const reservationNum = reservation?.reservation?.reservationNumber
  const isCancellation = reservation?.reservation?.reservationStatus === 'CANCELLED';

  useEffect(() => {
    if(!isConfirmationPageAccessible) {
      history?.push(`/${locale}/`);
    } else {
      dispatch(setIsConfirmationPageAccessible(false));
    }
  }, [history]);

  const ReservationCanceledConfirmation = () => {
    return (
      <>
        <img src={CrossIcon} alt='cross icon' className='crossIcon' height='56' width='56'/>
        <div className='InfoMsg' data-testid='infoMsg'>
          <Typography variant='h3'>{staticConstants.cancelConfirmationMsg(reservationNum)}</Typography>
        </div>
      </>
    )
  }

  const ReservationBookedConfirmation = () => {
    return (
      <>
        <img src={CheckIcon} alt='check icon' className='CheckIcon' height='56' width='56'/>
        <div className='ConfirmationMsgSection'>
          <p className='ConfirmationMsg'>{staticConstants?.thankYouMsg}{`${userData?.firstName} ${userData?.lastName}`}.</p>
          <p className='ConfirmationMsg'>{!!reservationId? 'Your reservation has been updated.' : staticConstants.confirmationMsg(reservationNum)}</p>
        </div>
        <div className='InfoMsg' data-testid='infoMsg'>
          <Typography fontFamily="Aeonik Regular">{staticConstants?.editInfoMessage}</Typography>
        </div>
      </>
    )
  }

  return (
    <>
      <div className='ReservationConfirmationPage'>
        <div className='ContentSection'>
          {isCancellation ? <ReservationCanceledConfirmation /> : <ReservationBookedConfirmation />}
        </div>
        <div className='ButtonsGroup'>
          {!isCancellation && <Button
              buttonType='mds-secondary'
              data-testid='editReservationButton'
              sx={{ padding: "16px 24px", textTransform: "none" }}
              onClick={() => history.push(`/${locale}/reservation/${reservation?.reservation?.reservationId}`)}
            >
              {staticConstants?.editReservationButtonLabel}
            </Button>
          }
          <Button
            buttonType='mds-primary'
            data-testid='newReservationButton'
            sx={{ padding: "16px 24px", textTransform: "none"}}
            onClick={() => history.push(`/${locale}/reservation`)}
          >
            {staticConstants?.newReservationButtonLabel}
          </Button>
        </div>
      </div>
    </>
  )
}

export default ReservationConfirmationPage
